import "../css"

$(function() {
  $(".content_modal").modal({ show: false })
})
